import React, { FC } from 'react'
import { ViewState } from './DepositState'
import { ErrorMessage } from '../../catalog/ErrorMessage'

interface Props {
  state: ViewState
}

export const FailDepositPanel: FC<Props> = ({ state }: Props) => {
  const message = (state.subState && state.subState.message) || 'Unknown error'

  return (
    <div style={{display:'flex',justifyContent:'center'}}>
      <ErrorMessage>{message}</ErrorMessage>
    </div>
  )
}
